/* import __COLOCATED_TEMPLATE__ from './custom-action-header-content.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import safeWindowOpen from 'embercom/lib/safe-window-open';
import { action } from '@ember/object';

interface Args {
  workflowAction: $TSFixMe;
  deleteAction: () => void;
  isSaveDisabled: boolean;
  saveErrorMessage: string;
  saveAction: () => void;
  setLive: () => void;
  setLiveErrorMessage: string;
  moveToDraft: () => void;
  isSaving: boolean;
}

interface Signature {
  Args: Args;
  Element: Element;
}

export default class CustomActionHeaderContent extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare appService: $TSFixMe;
  @service declare intercomEventService: $TSFixMe;

  @action
  askAnExpert() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'ask_an_expert_button',
      place: 'action_builder',
    });
  }

  get groupList() {
    return [
      {
        items: [
          ...(this.appService.app.isStandaloneApp
            ? []
            : [
                {
                  text: this.intl.t('workflow-connector.actions.hero-banner.learn-more', {
                    copyChangeActionsToDataConnectors:
                      this.appService.app.copyChangeActionsToDataConnectors,
                  }),
                  icon: 'article',
                  onSelectItem: () =>
                    safeWindowOpen(
                      'https://www.intercom.com/help/en/collections/3510275-custom-actions-objects',
                      '_blank',
                    ),
                },
              ]),
          {
            text: this.intl.t('workflow-connector.builder.side-drawer.button.delete', {
              copyChangeActionsToDataConnectors:
                this.appService.app.copyChangeActionsToDataConnectors,
            }),
            icon: 'trash',
            isDestructive: true,
            onSelectItem: () => this.args.deleteAction(),
            isDisabled: this.args.workflowAction.state !== 'draft',
            tooltipText: this.intl.t(
              'workflow-connector.builder.side-drawer.button.delete-tooltip',
              {
                copyChangeActionsToDataConnectors:
                  this.appService.app.copyChangeActionsToDataConnectors,
              },
            ),
          },
        ],
      },
    ];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::CustomActionHeaderContent': typeof CustomActionHeaderContent;
    'workflow-connector/custom-action-header-content': typeof CustomActionHeaderContent;
  }
}
